<template>
  <div class="wrapper">
    <div class="content">
      請使用網頁版開啟
    </div>
  </div>
</template>
<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router';
const router = useRouter()
onMounted(async ()=>{
  let isPc = []
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  for (var v = 0; v < Agents.length; v++) {
      await isPc.push(userAgentInfo.indexOf(Agents[v]) < 0)
  }
  if(!isPc.includes(false)){
    router.push('/sign')
  }
})
</script>
<style lang="scss" scoped>
.wrapper{
  width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
}
.content{
  width: 80%;
    height: 7rem;
    background: white;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
